// Environment hints attached to client crash reports (2026-09-14).
//
// The recurring insertBefore/removeChild NotFoundError crashes are the classic
// signature of SOMETHING outside React mutating a React-managed subtree
// (facebook/react#11538). The two known culprits leave detectable traces:
//
//   - Chrome page translation adds `translated-ltr` / `translated-rtl` to
//     <html> and wraps translated text nodes in <font> tags.
//   - Extensions (Grammarly, password managers, ad injectors) leave no common
//     marker, but a clean translate signal + a crash still points at them.
//
// Pure client code (window/document/navigator only) — safe to import from any
// client component, including app/global-error.tsx.

export interface ClientErrorEnv {
  ua?: string;
  htmlClass?: string;
  hasFontTag?: boolean;
  langs?: string;
}

export function collectClientErrorEnv(): ClientErrorEnv {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return {};
  }
  let hasFontTag = false;
  try {
    hasFontTag = !!document.querySelector("font");
  } catch {
    // ignore
  }
  let langs = "";
  try {
    langs = ((navigator.languages as readonly string[] | undefined) || [navigator.language])
      .filter(Boolean)
      .join(",");
  } catch {
    // ignore
  }
  return {
    ua: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    htmlClass: document.documentElement ? document.documentElement.className : "",
    hasFontTag,
    langs,
  };
}
